module.exports = __webpack_public_path__ + "img/travelearth_image.88b6e181.png";